import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'
// import Select from 'react-select'
import Button from '../../common/CustomComponents/Button'
import Toggle from 'react-toggle'

class AirportList extends React.Component {
  state = {
    countryData: null,
    country_list: [],
    airport_data: [],
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    country: '',

    show_city: true,
    show_airport: true,

    isSearching: false,
  }

  debounceTimeout = null

  componentDidMount() {
    this.getAirportList()
    this.getCountries()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/admin/get-airport-countries', {
        headers: { Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}` },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data?.map((ele) => {
              return { label: `${ele.country}/${ele.country_ar}`, value: ele.country }
            }),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getAirportList = async () => {
    this.setState({
      isSearching: true,
      open: true,
      airport_data: [],
    })

    const data = {
      country: this.state.countryData?.value,
      query: this.state.keyword,
      show_city: this.state.show_city,
      show_airport: this.state.show_airport,
      pageNumber: this.state.pageNumber,
      limit: this.state.limit,
    }

    await axios
      .post(Constant.getAPI() + `/admin/get-airports`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            airport_data: res.data.data,
            open: false,
            disabled: !res.data.data?.length > 0,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  handleChange = (event) => {
    event.persist()
    const fieldName = event?.target?.name
    const fieldValue = event?.target?.value

    this.setState({
      [fieldName]: fieldValue,
    })

    // Auto-search with debounce for keyword field
    if (fieldName === 'keyword') {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout)

      this.debounceTimeout = setTimeout(() => {
        this.setState(
          {
            pageNumber: 0,
          },
          () => {
            this.getAirportList()
          }
        )
      }, 500)
    }
  }

  handleCountryChange = (event) => {
    this.setState({
      countryData: event,
    })
  }

  handleClear = () => {
    this.setState({ countryData: null })
  }

  searchData = async () => {
    this.setState(
      {
        limit: 10,
        pageNumber: 0,
      },
      () => {
        this.getAirportList()
      }
    )
  }

  clearFilters = () => {
    this.setState({
      country: '',
      countryData: null,
      keyword: '',

      limit: 10,
      pageNumber: 0,

      airport_data: [],
    })
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  handleStatusChange = async (id, isActive, type) => {
    const data = {
      id: id,
      [type]: isActive,
    }

    await axios
      .put(Constant.getAPI() + '/admin/update-airport', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.getAirportList()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'iata_code',
        label: 'IATA Code',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'type',
        label: 'Type',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) =>
            value ? <div style={{ textWrap: 'nowrap', textTransform: 'capitalize' }}>{value}</div> : '--',
        },
      },
      {
        name: 'name',
        label: 'Airport Name',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'city',
        label: 'City',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'country',
        label: 'Country',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'is_popular',
        label: 'Popular',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={!!is_active}
                onChange={this.handleStatusChange.bind(this, id, !is_active, 'is_popular')}
              />
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <Toggle
                id={id}
                checked={!!is_active}
                onChange={this.handleStatusChange.bind(this, id, !is_active, 'is_active')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (booking, tableMeta) => {
            const id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div>
                <Link
                  to={`/airport/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: true,
      search: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
          />
        )
      },

      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.getAirportList()
          }
        )
      },

      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
          },
          () => {
            this.getAirportList()
          }
        )
      },

      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="pcoded-inner-content">
          <div className="main-body">
            <div className="page-wrapper">
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div className="d-inline">
                        <h4>Airport list</h4>
                      </div>
                    </div>
                    <Link
                      to={`/airport/add`}
                      className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                      data-modal="modal-13"
                    >
                      <i className="icofont icofont-plus m-r-5"></i> Add Airport
                    </Link>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <ul className="breadcrumb-title">
                        <li className="breadcrumb-item">
                          <Link to="/">
                            <i className="feather icon-home"></i>{' '}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Airport List</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-border-default">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">Search</label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  id="keyword"
                                  className="form-control"
                                  value={this.state.keyword}
                                  name="keyword"
                                  placeholder="Airport Name | IATA | City | Country"
                                  onKeyPress={this.handleKeyPress}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">Show City</label>
                              <div className="col-md-9">
                                <Toggle
                                  id="city"
                                  checked={!!this.state.show_city}
                                  onChange={() => {
                                    this.setState({
                                      show_city: !this.state.show_city,
                                    })
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">Show Airport</label>
                              <div className="col-md-9">
                                <Toggle
                                  id="airport"
                                  checked={!!this.state.show_airport}
                                  onChange={() => {
                                    this.setState({
                                      show_airport: !this.state.show_airport,
                                    })
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          {/* 
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Country</label>
                              <div className="col-sm-9">
                                <Select
                                  name="countryData"
                                  value={this.state.countryData}
                                  onChange={this.handleCountryChange}
                                  options={this.state.country_list}
                                  isMulti={false}
                                  isSearchable={true}
                                  isClearable
                                  onClear={this.handleClear}
                                  placeholder="Select Options"
                                />
                              </div>
                            </div>
                          </div> */}
                          <div className="col-md-12">
                            <div className="form-group row mb-0">
                              <div className="text-left col">
                                <Button
                                  onClick={this.searchData}
                                  disabled={this.state.isSearching}
                                >
                                  {this.state.isSearching ? 'Searching...' : 'Search'}
                                </Button>
                                <Button
                                  variant={'outlined'}
                                  onClick={this.clearFilters}
                                >
                                  Clear
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-block">
                        <div className="dt-responsive table-responsive">
                          <MUIDataTable
                            title={'Airport List'}
                            className="table-responsive"
                            data={this.state.airport_data}
                            columns={columns}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default AirportList
